import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=bfea78be&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=bfea78be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfea78be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfea78be')) {
      api.createRecord('bfea78be', component.options)
    } else {
      api.reload('bfea78be', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=bfea78be&scoped=true&", function () {
      api.rerender('bfea78be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26v8HCBm4d7RV/JS/teamMember.vue"
export default component.exports